// FIXME: Update this file to be type safe and remove this and next line
// @ts-strict-ignore
export class FederatedUserContext {
  username: string;
  idpUserInfo: any;
  accessToken: string;
  idToken: string;
}
